/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import isEqual from 'lodash/isEqual';
import { getDateObject, getSiteId, isCanada } from '@tcp/core/src/utils/utils';
import {
  getIcidValue,
  fireEnhancedEcomm,
  filterQuantityLabels,
  scrollToBreadCrumb,
  isMobileWeb,
  getBrandInCaps,
  formatPromotionMessage,
  getViewportInfo,
  isClient,
  internalCampaignProductAnalyticsList,
  internalPromotionFormattedProducts,
  getSessionStorage,
  removeSessionStorage,
} from '@tcp/core/src/utils';
import { getOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import { setLocalStorage, getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getPageNumberFromUrl, getSearchRedirectObj } from '@tcp/core/src/utils/utils.web';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf/RenderPerf';
import { CONTROLS_VISIBLE, RESULTS_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import { setProp } from '@tcp/core/src/analytics/utils';
import {
  SearchListingViewPropTypes,
  SearchListingViewDefaultProps,
  redirectToSuggestedUrl,
  enteredSearchText,
  getSearchText,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.util';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import PLPSkeleton from '@tcp/core/src/components/common/atoms/PLPSkeleton';
import ANALYTICS_CONSTANTS from '@tcp/web/src/constants/AnalyticsConstants';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import processHelpers from '@tcp/core/src/services/abstractors/productListing/processHelpers';
import {
  getGeneralProductId,
  setPriceRange,
  extractAttributeValue,
  attributeListMaker,
} from '@tcp/core/src/services/abstractors/productListing/productParser';
import withStyles from '../../../../common/hoc/withStyles';
import SearchListingStyle from '../SearchDetail.style';
import ProductsGrid from '../../ProductListing/molecules/ProductsGrid/views';
import LoadedProductsCount from '../../ProductListing/molecules/LoadedProductsCount/views';
import errorBoundary from '../../../../common/hoc/withErrorBoundary';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import SideBar from '../../ProductListing/views/SideBar';
import { isFiltersAvailable } from '../../ProductListing/container/ProductListing.selectors';
import PromoModules from '../../../../common/organisms/PromoModules';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import ToastModal from '../../../account/common/molecule/ToastModal/views/ToastModal';
import { SLP_SUB_LABELS, slpSubLabels } from '../../../../../utils/labels/browse/SLP.labels';
import {
  getDynamicLabelValues,
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import SearchTileGridView from './SearchTileGrid.view';

const SyteVendorScript = dynamic(() => import('@tcp/web/src/components/common/vendors/Syte/Syte'));
const SearchKeywords = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "search-keywords" */ './SearchKeywords.view'
  )
);

const ProductListingFiltersForm = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "product-listing-filters-form" */ '../../ProductListing/molecules/ProductListingFiltersForm'
    ),
  {
    ssr: false,
  }
);

const Paginator = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "paginator" */ '@tcp/core/src/components/common/molecules/Paginator'
    ),
  { ssr: false }
);

const BundleTrackerContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "bundle-tracker-container" */ '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.container'
    ),
  { ssr: false }
);

const ProductDisplay = ({
  acrossBrandApiCalled,
  isSLPNewTileImplementationEnabled,
  crossBrandProducts,
  productsBlock,
  alternateBrand,
  alternateBrandsShown,
  resetSlpLoadingState,
  otherProps,
  sharedProps,
  newTileCommonProps,
  oldTileCommonProps,
}) => {
  if (!acrossBrandApiCalled) {
    if (isSLPNewTileImplementationEnabled) {
      return <SearchTileGridView {...sharedProps} {...newTileCommonProps} />;
    }
    return (
      <ProductsGrid
        {...sharedProps}
        {...oldTileCommonProps}
        {...otherProps}
        productsBlock={productsBlock}
        alternateBrand={alternateBrand}
        isSLP
      />
    );
  }

  return crossBrandProducts?.map((item, index) => {
    if (isSLPNewTileImplementationEnabled) {
      return (
        <SearchTileGridView
          {...sharedProps}
          {...newTileCommonProps}
          key={index}
          acrossBrandApiCalled={acrossBrandApiCalled}
          resetSlpLoadingState={resetSlpLoadingState}
          alternateBrandsShown={alternateBrandsShown[index]}
        />
      );
    }
    return (
      <ProductsGrid
        {...sharedProps}
        {...oldTileCommonProps}
        {...otherProps}
        key={index}
        productsBlock={[item]}
        alternateBrand={alternateBrandsShown[index]}
        isSLP
        acrossBrandApiCalled={acrossBrandApiCalled}
        alternateBrandsShown={alternateBrandsShown[index]}
      />
    );
  });
};

class SearchListingView extends React.Component {
  multipackLabel = getDynamicLabelValues(`dynamic.browse_d.lbl_multipack_pack_text`);

  slpLabels = {
    ...getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels),
    lbl_multipack_pack_text: this.multipackLabel,
  };

  constructor(props) {
    super(props);

    this.colSize = {
      variant1: { small: 6, medium: 8, large: 12 },
      variant2: { small: 6, medium: 8, large: 10 },
      variant3: { small: 6, medium: 8, large: 2.5 },
      variant4: { small: 6, medium: 8, large: 9.5 },
      variant5: { small: 6, medium: 8, large: 12 },
    };

    this.state = {
      hasMounted: false,
    };
  }

  shouldComponentUpdate(nextProps) {
    if (isEqual(nextProps, this.props)) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  componentDidUpdate(prevProps) {
    const {
      products,
      isPlpPdpAnchoringEnabled,
      shouldSlpScrollState,
      resetSlpScrollState,
      isSlpSsr,
    } = this.props;
    const productsFormatted = this.formatProductsData(products);
    if (prevProps.products !== products && productsFormatted.length > 0) {
      this.triggerAnalyticsCall();
      const searchTimer = setTimeout(() => {
        this.triggerAdobeAnalytics();
        clearTimeout(searchTimer);
      }, 1000);
    }
    if (isPlpPdpAnchoringEnabled && shouldSlpScrollState && isMobileWeb()) {
      if (!isSlpSsr) {
        scrollToBreadCrumb();
      }
      resetSlpScrollState();
    }
  }

  getSearchRedirection = (searchedText) => {
    const searchRedirect = getSearchRedirectObj();
    if (searchRedirect && searchRedirect.isDone) return searchRedirect.searchTerm;
    return searchedText;
  };

  relatedSearchEventArrayCheck = (isRelatedSearchTermClick, analyticsEvents) => {
    return isRelatedSearchTermClick && !analyticsEvents.includes('event20');
  };

  getSearchType = (searchedText, searchType, isDidYouMeanEnabled) => {
    const searchText = getSearchText(searchedText);
    return searchText !== enteredSearchText() && isDidYouMeanEnabled
      ? 'did you mean search'
      : searchType;
  };

  getAnalyticSV = (analyticSV) => {
    return typeof analyticSV === 'object' ? JSON.stringify(analyticSV) : analyticSV;
  };

  sendAdobePageViewEvent = (pageDataAdobe, User, APIConfig, session) => {
    return new Promise((resolve) => {
      pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
      resolve();
    });
  };

  // eslint-disable-next-line max-statements
  triggerAnalyticsCall = () => {
    const {
      products,
      trackPageLoad,
      searchType,
      searchedText,
      asPathVal,
      filterCount,
      initialValues,
      totalProductsCount,
      currency,
      isDidYouMeanEnabled,
      User,
      APIConfig,
      session,
      router,
    } = this.props;
    let selectedPage = getPageNumberFromUrl();
    const { asPath } = router;
    // eslint-disable-next-line radix
    selectedPage = selectedPage ? parseInt(selectedPage) : 1;
    const { sort } = initialValues;
    const productsFormatted = this.formatProductsData(products);
    const icid = getIcidValue(asPathVal);
    let analyticsEvents = ['event91', 'event92', 'event80', 'event81'];
    let internalCampaignId = '';
    const searchTerm = isShopThisStoreModeOn()
      ? this.getSearchRedirection(searchedText).split('?')[0]
      : this.getSearchRedirection(searchedText);
    const cd78SearchTerm = searchTerm?.split('?')[0] || searchTerm;
    const SearchType = this.getSearchType(
      isShopThisStoreModeOn() ? searchedText.split('?')[0] : searchedText,
      searchType,
      isDidYouMeanEnabled
    );

    let analyticSV = getSessionStorage('AnalyticsObj');
    analyticSV = this.getAnalyticSV(analyticSV);
    const analyticsObj = (analyticSV && analyticSV.length && JSON.parse(analyticSV)) || {};
    let listingCount = products ? totalProductsCount : '';
    let pageSearchText;
    let pageSearchType;

    if (icid) {
      internalCampaignId = icid;
      if (analyticsObj?.search?.searchTypeFirstTouch === ANALYTICS_CONSTANTS.bannerSearchClick) {
        pageSearchText = `${searchedText?.split('?')[0]}`;
        pageSearchType = ANALYTICS_CONSTANTS.bannerSearchClick;
        analyticsEvents = ['event20', 'event91', 'event81'];
      }
    } else {
      pageSearchText = searchTerm;
      pageSearchType = SearchType;
      analyticsEvents = ['event91', 'event92', 'event80', 'event20'];
      setProp('eVar94', '+1');
    }

    // Ignore below variables if sort or filter applied
    if (
      sort ||
      (filterCount && !isShopThisStoreModeOn()) ||
      sort ||
      (filterCount > 1 && isShopThisStoreModeOn())
    ) {
      analyticsEvents = ['event91', 'event92', 'event80'];
      internalCampaignId = ''; // evar19
      pageSearchText = ''; // evar26
      listingCount = 0; // evar27
      pageSearchType = ''; // eVar59
    } else {
      setProp('eVar22', 'internal search');
    }
    const promotionalProducts = internalCampaignProductAnalyticsList();

    const isRelatedSearchTermClick = getSessionStorage('relatedSearch') || '';
    if (this.relatedSearchEventArrayCheck(isRelatedSearchTermClick, analyticsEvents)) {
      analyticsEvents.push('event20');
    }
    let searchTypeFinal = pageSearchType;
    if (isRelatedSearchTermClick) {
      searchTypeFinal = 'related search';
    }
    if (isShopThisStoreModeOn()) {
      searchTypeFinal = 'shop the store search';
    }
    trackPageLoad({
      products: productsFormatted,
      pageSearchType,
      pageSearchText,
      pageType: 'search',
      pageName: 'search:results',
      pageSection: 'search',
      pageSubSection: 'search',
      searchType: searchTypeFinal,
      customEvents: [...analyticsEvents, 'event78'],
      listingCount,
      listingSortList: 'sort=recommended',
      internalCampaignId,
      slpPage_cd78: `${cd78SearchTerm}|p${selectedPage}`,
      relatedSearchTerm: isRelatedSearchTermClick,
    });
    fireEnhancedEcomm({
      eventName: 'productimpression',
      productsObj: productsFormatted,
      eventType: 'impressions',
      pageName: 'Search',
      currCode: currency,
      eventLabel: 'Product impression',
    });
    if (promotionalProducts) {
      fireEnhancedEcomm({
        eventName: 'internalcampaignimpression',
        productsObj: internalPromotionFormattedProducts(promotionalProducts),
        eventType: 'promoView',
        pageName: 'Search Listing Page',
        currCode: 'USD',
      });
    }

    const pageDataAdobe = {
      pageName: 'search results',
      pageSection: 'search',
      pageType: 'search page',
      pageSubSection: '',
      pageSubSection2: '',
      pagination: asPath?.split('page=')?.[1],
    };
    this.sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session).then(() => {
      pushEventToAdobeAnalytics('product_impression', {
        productImpressions: productsFormatted,
        pageView: { pageData: pageDataAdobe, User, APIConfig, session },
      });
      pushEventToAdobeAnalytics(
        'promotional_banner_impression',
        internalPromotionFormattedProducts(promotionalProducts)
      );
    });
    removeSessionStorage('relatedSearch');
  };

  formatProductsData = (products) => {
    const {
      currency,
      router,
      searchedText = '',
      isHideOriginalPriceAndMarchantTagEnabled,
      promotionsData = {},
      isSLPNewTileImplementationEnabled,
      mostFavoritedAttributeSLP,
      bestSellerAttributeSLP,
      topRatedAttributeSLP,
    } = this.props;
    const brand = getBrandInCaps();
    if (isSLPNewTileImplementationEnabled) {
      return products && products.length
        ? products.map((tile, index) => {
            const {
              TCPCustomSalePrice,
              TCPCustomListPrice,
              tcp_promotion_id: TCPPromotionID,
              is_hard_mark_enable: hardMarkDown,
              uniqueId,
            } = tile;
            const generalProductId = getGeneralProductId(tile);
            const offerPrice =
              parseFloat(TCPCustomSalePrice) || processHelpers.getOfferPriceResponse(tile);
            const listPrice =
              parseFloat(TCPCustomListPrice) || processHelpers.getListPriceResponse(tile);
            const { lowOfferPrice } = setPriceRange(tile);
            const productBadge = [
              extractAttributeValue(tile, mostFavoritedAttributeSLP) ? 'most favorite' : '',
              extractAttributeValue(tile, bestSellerAttributeSLP) ? 'best seller' : '',
              extractAttributeValue(tile, topRatedAttributeSLP) ? 'top rated' : '',
            ]
              ?.filter(Boolean)
              ?.join(',');

            const searchQuery =
              searchedText || (router && router.query && router.query.searchQuery) || '';
            const searchTerm = searchQuery ? `search-${searchQuery}` : '';
            const originalPrice = getOriginalPrice({
              hardMarkDown,
              isHideOriginalPriceAndMarchantTagEnabled,
              listPrice,
              currency,
            });
            return {
              id: generalProductId,
              category: searchTerm,
              colorId: generalProductId,
              price: offerPrice,
              dimension35: brand,
              listPrice,
              extPrice: lowOfferPrice,
              dimension63: `${offerPrice}${currency} ${originalPrice}`,
              dimension67: offerPrice < listPrice ? 'on sale' : 'full price',
              dimension80: undefined,
              dimension89: generalProductId,
              dimension100: index + 1,
              dimension56: promotionsData[TCPPromotionID]
                ? formatPromotionMessage(promotionsData, TCPPromotionID)
                : '',
              productBadge,
              uniqueId,
            };
          })
        : [];
    }
    return products && products.length
      ? products.map((tile, index) => {
          const {
            productInfo: {
              listPrice,
              offerPrice,
              generalProductId,
              priceRange,
              hardMarkDown,
              TCPPromotionID,
            },
            miscInfo: { categoryName },
            colorsMap,
            uniqueId,
          } = tile;
          const productBadge = [
            colorsMap?.[0]?.miscInfo?.mostFavoritedSLP ? 'most favorite' : '',
            colorsMap?.[0]?.miscInfo?.bestSellerSLP ? 'best seller' : '',
            colorsMap?.[0]?.miscInfo?.topRatedSLP ? 'top rated' : '',
          ]
            ?.filter(Boolean)
            ?.join(',');
          const searchQuery =
            searchedText || (router && router.query && router.query.searchQuery) || '';
          const searchTerm = searchQuery ? `search-${searchQuery}` : '';
          const originalPrice = getOriginalPrice({
            hardMarkDown,
            isHideOriginalPriceAndMarchantTagEnabled,
            listPrice,
            currency,
          });
          return {
            id: generalProductId,
            category: searchTerm,
            colorId: generalProductId,
            price: offerPrice,
            dimension35: brand,
            listPrice,
            extPrice: priceRange?.lowOfferPrice,
            dimension63: `${offerPrice}${currency} ${originalPrice}`,
            dimension67: offerPrice < listPrice ? 'on sale' : 'full price',
            dimension80: categoryName,
            dimension89: generalProductId,
            dimension100: index + 1,
            dimension56: promotionsData[TCPPromotionID]
              ? formatPromotionMessage(promotionsData, TCPPromotionID)
              : '',
            productBadge,
            uniqueId,
          };
        })
      : [];
  };

  getSearchString = (text) => {
    const { isLoadingMore, totalProductsCount } = this.props;
    if (!isLoadingMore && totalProductsCount > 0) {
      return text;
    }
    return '';
  };

  getSkeltonBlock = (products) => {
    const { isLoadingMore } = this.props;
    return isLoadingMore || JSON.stringify(products) === '{}' ? <PLPSkeleton col={20} /> : null;
  };

  getSearchResultSuggestionsArg = () => {
    const { searchResultSuggestions } = this.props;
    return searchResultSuggestions && searchResultSuggestions.length
      ? searchResultSuggestions.map((searchSuggestion) => searchSuggestion.suggestion)
      : renderLabel(this.slpLabels.lbl_no_suggestion, 'lbl_no_suggestion');
  };

  renderOldLoadedProductsCount = () => {
    const {
      totalProductsCount,
      isABTestForStickyFilter,
      isPaginationViewEnabled,
      productsBlock,
      productLimitPerPage,
      selectedPage,
      isOneHrFilterEnabled,
    } = this.props;
    const selectedPageProductCount = productsBlock[0]?.length || 0;
    return !isABTestForStickyFilter ? (
      <Row className={`${isOneHrFilterEnabled ? 'mb-24' : ''}`}>
        <Col
          colSize={this.colSize.variant1}
          className={`${isOneHrFilterEnabled ? 'half-width' : ''}`}
        >
          <LoadedProductsCount
            className="show-items-count-section"
            totalProductsCount={totalProductsCount}
            isPaginationViewEnabled={isPaginationViewEnabled}
            selectedPageProductCount={selectedPageProductCount}
            productLimitPerPage={productLimitPerPage}
            selectedPage={selectedPage}
            isSLP
          />
        </Col>
      </Row>
    ) : null;
  };

  processSearchText = (search) => {
    return search?.split('?')?.[0]?.split('&')?.[0];
  };

  getAppliedFilters = (initialValues, filterMaps) => {
    const appliedFilters = [];
    const keys = Object.keys(initialValues).sort();
    for (let index = 0; index < keys.length; index += 1) {
      const selectedFacet = filterMaps[keys[index]]
        ? initialValues[keys[index]].map((filterId) =>
            filterMaps[keys[index]].find((filter) => filterId === filter.id)
          )
        : [];
      appliedFilters.push(selectedFacet);
    }
    return appliedFilters;
  };

  constructImageUrl = (url) => {
    if (url?.includes('_')) {
      return `${url?.split('_')?.[0]}/${url}`;
    }
    return `${url?.split('.')?.[0]}/${url}`;
  };

  deleteOldSearches = (prevSearch, numberOfSearchesToStore) => {
    if (Object.keys(prevSearch)?.length > numberOfSearchesToStore) {
      let prevSearchArray = Object.entries(prevSearch)?.map(([key, value]) => ({ key, value }));
      prevSearchArray = prevSearchArray.sort(
        (a, b) => getDateObject(b?.value?.[1]) - getDateObject(a?.value?.[1])
      );
      prevSearchArray = prevSearchArray?.slice(0, numberOfSearchesToStore);
      return Object.assign(...prevSearchArray.map((ele) => ({ [ele.key]: ele.value })));
    }
    return prevSearch;
  };

  prevSearchUpdate = (
    prevSearch,
    filtersAppliedPrevSearch,
    currentTimestamp,
    prevSearchImageArray,
    searchedText
  ) => {
    let prevSearchUpdated = prevSearch;
    if (prevSearchUpdated?.[searchedText]) {
      prevSearchUpdated[searchedText] = [
        filtersAppliedPrevSearch,
        currentTimestamp,
        prevSearchImageArray,
      ];
    } else if (searchedText?.length) {
      prevSearchUpdated = {
        ...prevSearchUpdated,
        [`${searchedText.split('?')[0]}`]: [
          filtersAppliedPrevSearch,
          currentTimestamp,
          prevSearchImageArray,
        ],
      };
    }
    return prevSearchUpdated;
  };

  webSearchCheck = (webSearchEnabled, products) => {
    return webSearchEnabled && products?.length;
  };

  plpSkeletonCheck = (isLoadingMore, products) => {
    return isLoadingMore || JSON.stringify(products) === '{}';
  };

  otherBrandCheck = (product, alternateBrand, prevSearch, searchedText) => {
    const productAttr = attributeListMaker(product?.list_of_attributes);
    const brand = isCanada()
      ? productAttr
          ?.find((attr) => attr.identifier === 'TCPPrimaryBrandCanadaStore')
          ?.value?.toLowerCase()
      : productAttr
          ?.find((attr) => attr.identifier === 'TCPPrimaryBrandUSStore')
          ?.value?.toLowerCase();
    const otherBrandValue = brand || product?.productInfo?.primaryBrand || alternateBrand;
    if (otherBrandValue.length === 0) {
      const productUrl = this.constructImageUrl(this.getProductImage(product));
      return (
        (prevSearch?.[searchedText]?.[2]?.[0] === productUrl &&
          prevSearch?.[searchedText]?.[2]?.[3]) ||
        otherBrandValue
      );
    }
    return otherBrandValue;
  };

  getProductImage = (product) => {
    return product?.colorsMap?.[0]?.productImage || `${product.uniqueId}.jpg`;
  };

  renderBundleTracker = (isBundleTrackerEnabled) => {
    return isBundleTrackerEnabled && <BundleTrackerContainer />;
  };

  // eslint-disable-next-line class-methods-use-this

  onPageChange = (pageProp) => {
    const page = pageProp || 1;
    const {
      router: { asPath },
      getPaginatedProducts,
      isDidYouMeanEnabled,
      searchedText,
    } = this.props;
    let paginationPath = asPath;

    if (searchedText && searchedText !== '*' && isDidYouMeanEnabled) {
      const wrongTerm = isShopThisStoreModeOn()
        ? paginationPath?.split('/')?.[4]
        : paginationPath?.split('/')?.[3];
      paginationPath = asPath.replace(wrongTerm, searchedText);
    }
    getPaginatedProducts({ url: paginationPath, selectedPage: page });
    scrollToBreadCrumb();
  };

  getNumberOfSearches = (isSearchEnhancementRedesignEnabled) => {
    const isTabletFlag = isClient() ? getViewportInfo().isTablet : null;
    if (isSearchEnhancementRedesignEnabled) {
      if (isTabletFlag) {
        return 3;
      }
      return 4;
    }
    return 6;
  };

  triggerAdobeAnalytics = () => {
    const {
      searchType,
      searchedText,
      totalProductsCount,
      router: { asPath },
    } = this.props;
    const isDidYouMeanSearch = searchedText !== enteredSearchText();
    if (isDidYouMeanSearch) {
      const paginationPath = asPath;
      const wrongTerm = paginationPath.includes('?')
        ? paginationPath?.split('?')?.[0]?.split('/')?.[3]
        : paginationPath?.split('/')?.[3];
      pushEventToAdobeAnalytics('internal_search_error', {
        searchedText,
        wrongTerm,
        totalProductsCount,
      });
    } else {
      pushEventToAdobeAnalytics('internal_search', {
        searchedText,
        searchType,
        totalProductsCount,
      });
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const {
      className,
      products,
      productsBlock,
      plpLabels,
      totalProductsCount,
      searchedText,
      filters,
      filtersLength,
      formValues,
      getProducts,
      initialValues,
      onSubmit,
      currency,
      currencyAttributes,
      onAddItemToFavorites,
      isLoggedIn,
      isLoadingMore,
      isSearchListing,
      searchResultSuggestions,
      asPathVal,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      wishList,
      isHidePLPRatings,
      searchTopPromos,
      isPlcc,
      onSetLastDeletedItemIdAction,
      deleteFavItemInProgressFlag,
      shouldSlpScrollState,
      resetSlpScrollState,
      isPlpPdpAnchoringEnabled,
      isDynamicBadgeEnabled,
      isDynamicBadgeEnabledAbtest,
      isABTestForStickyFilter,
      isPromoApplied,
      breadCrumbs,
      dynamicPromoModules,
      isSecureImageFlagEnabled,
      alternateBrand,
      isShowBrandNameEnabled,
      isBopisFilterOn,
      updateFormValue,
      setBopisFilterStateActn,
      isBopisFilterEnabled,
      defaultStore,
      isPromoProductsSearch,
      isSTSSearch,
      trackWishListClick,
      isBundleTrackerEnabled,
      productLimitPerPage,
      isPaginationViewEnabled,
      selectedPage,
      isFilterBy,
      navTree,
      currentNavIds,
      isSLPExtendedView,
      newFilterTrackAnalytics,
      trackClickAnalyticsBopisFilter,
      isDidYouMeanEnabled,
      isSearchEnhancementRedesignEnabled,
      trackAnalyticsClick,
      isNewSwatchUrlEnabled,
      isSyteEnabled,
      searchResultKeywordSuggestions,
      slpPersistSearchTerm,
      isSlpPersistEnabled,
      isHeaderSticky,
      didYouMeanNullSearch,
      acrossBrandApiCalled,
      crossBrandProducts,
      alternateBrandsShown,
      isSizeGroupFilterEnabled,
      sortByRatingLabel,
      isHideOriginalPriceAndMarchantTagEnabled,
      isMostFavoritedBadgeEnabled,
      setPLPSLPAddToCartCTA,
      isCustomerRatingFilterWebEnabled,
      isTileRedesignAB,
      isInfluencerBadgeEnabled,
      toastModalState,
      showToastModalAction,
      isOneHrFilterEnabled,
      isGlobalHeaderRedesignEnabled,
      isHeaderScrollViewDisabled,
      isSLPNewTileImplementationEnabled,
      isFeatureBrandView,
      featureBrand,
      isFeatureBrandEnabled,
      isRandomBgColorEnabled,
      ...otherProps
    } = this.props;
    const {
      promotionsData,
      isInfluencerPicksEnabled,
      isUpdatedPromotionsDisplayEnabled,
      onQuickViewOpenClick,
      isBrierleyPromoEnabled,
      serverTime,
      isBuyMorePromoEnabled,
      trackClickPromotion,
      isInternationalShipping,
      addToBagEcom,
      isOneClickATCEnabled,
      deleteFavItemInProgressFlag: favAddRemoveLoadingState,
      isAlternateImageOnHoverEnabled,
      isShowPriceRangeKillSwitch: isShowPriceRangeEnabled,
      imageConfigWithoutDPR,
      topRatedAttributeSLP,
      bestSellerAttributeSLP,
      mostFavoritedAttributeSLP,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      resetSlpLoadingState,
      router,
      saveProductDataForQV,
      saveProductDataForPdp,
      isDynamicColorSwatchesEnabled,
      isHoverToPreviewColorSwatchesEnabled,
      isInteractiveColorSwatchBandEnabled,
      isFourTileGridEnabled,
      isSwatchAsColorUrlEnabled,
      isHoverToRevealATBButtonEnabled,
      isFinalSaleABEnabled,
    } = otherProps;

    const sharedProps = {
      products,
      isLoggedIn,
      isPlcc,
      isNewSwatchUrlEnabled,
      isHideOriginalPriceAndMarchantTagEnabled,
      isInfluencerBadgeEnabled,
      isTileRedesignAB,
      setPLPSLPAddToCartCTA,
      isMostFavoritedBadgeEnabled,
      onAddItemToFavorites,
      onSetLastDeletedItemIdAction,
      wishList,
      isBopisFilterOn,
      trackWishListClick,
      asPathVal,
      currency,
      isFourTileGridEnabled,
      isSwatchAsColorUrlEnabled,
      isRandomBgColorEnabled,
      isDynamicBadgeEnabled,
      isDynamicBadgeEnabledAbtest,
    };

    const newTileCommonProps = {
      isInfluencerPicksEnabled,
      isUpdatedPromotionsDisplayEnabled,
      onQuickViewOpenClick,
      isBrierleyPromoEnabled,
      promotionsData,
      serverTime,
      isBuyMorePromoEnabled,
      trackClickPromotion,
      isInternationalShipping,
      addToBagEcom,
      isOneClickATCEnabled,
      favAddRemoveLoadingState,
      isAlternateImageOnHoverEnabled,
      isShowPriceRangeEnabled,
      imageConfigWithoutDPR,
      topRatedAttributeSLP,
      bestSellerAttributeSLP,
      mostFavoritedAttributeSLP,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      searchQuery: router?.query?.searchQuery,
      saveProductDataForQV,
      saveProductDataForPdp,
      isDynamicColorSwatchesEnabled,
      isHoverToPreviewColorSwatchesEnabled,
      isInteractiveColorSwatchBandEnabled,
      isHoverToRevealATBButtonEnabled,
      isFeatureBrandEnabled,
      isFinalSaleABEnabled,
    };

    const oldTileCommonProps = {
      className,
      productTileVariation: 'search-product-tile',
      currencyAttributes,
      isLoadingMore,
      isSearchListing,
      getProducts,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      totalProductsCount,
      isHidePLPRatings,
      deleteFavItemInProgressFlag,
      isDynamicBadgeEnabled,
      isPromoApplied,
      isSecureImageFlagEnabled,
      isShowBrandNameEnabled,
      isPaginationViewEnabled,
      trackAnalyticsClick,
      isSyteEnabled,
      selectedPage,
      isDynamicBadgeEnabledAbtest,
    };
    const { hasMounted } = this.state;
    const isDesktopFlag = isClient() && getViewportInfo().isDesktop;
    const { resetSuggestedStores, currentListingName } = otherProps;
    const searchResultSuggestionsArg = this.getSearchResultSuggestionsArg();
    const filterMaps = filterQuantityLabels(filters, this.slpLabels);
    const hideOnPageChange = isPaginationViewEnabled && isLoadingMore;
    const webSearchEnabled = true;
    if (this.webSearchCheck(webSearchEnabled, products)) {
      const filtersAppliedPrevSearch = this.getAppliedFilters(initialValues, filterMaps);
      const prevSearchImageArray = [];
      const numberOfImages = 1;
      const numberOfSearchesToStore = this.getNumberOfSearches(isSearchEnhancementRedesignEnabled);
      let prevSearch = JSON.parse(getLocalStorage('prevSearch'));
      products?.slice(0, numberOfImages)?.forEach((product) => {
        prevSearchImageArray.push(this.constructImageUrl(this.getProductImage(product)));
        if (numberOfImages < 3) {
          prevSearchImageArray.push(this.constructImageUrl(this.getProductImage(product)));
          prevSearchImageArray.push(this.constructImageUrl(this.getProductImage(product)));
        }
        prevSearchImageArray.push(
          this.otherBrandCheck(product, alternateBrand, prevSearch, searchedText)
        );
      });
      const currentTimestamp = getDateObject();
      prevSearch = this.prevSearchUpdate(
        prevSearch,
        filtersAppliedPrevSearch,
        currentTimestamp,
        prevSearchImageArray,
        searchedText
      );

      prevSearch = this.deleteOldSearches(prevSearch, numberOfSearchesToStore);

      setLocalStorage({ key: 'prevSearch', value: JSON.stringify(prevSearch) });
    }
    const stickySortClass = !acrossBrandApiCalled ? 'sticky-sort' : '';
    const selectedPageProductCount = productsBlock[0]?.length || 0;
    const Syte = isSyteEnabled ? SyteVendorScript : () => null;
    return (
      <>
        {this.renderBundleTracker(isBundleTrackerEnabled)}

        <div className={`${className}${isSLPExtendedView ? ' slp-extended-view' : ''}`}>
          <Row fullBleed>
            {!acrossBrandApiCalled && (
              <Col colSize={this.colSize.variant3}>
                {isDesktopFlag && (
                  <SideBar
                    filtersMaps={filterMaps}
                    totalProductsCount={totalProductsCount}
                    initialValues={initialValues}
                    filtersLength={filtersLength}
                    onSubmit={onSubmit}
                    formValues={formValues}
                    getProducts={getProducts}
                    slpLabels={this.slpLabels}
                    isFilterBy={isFilterBy}
                    isLoadingMore={isLoadingMore}
                    isABTestForStickyFilter={isABTestForStickyFilter}
                    isBopisFilterEnabled={isBopisFilterEnabled}
                    isBopisFilterOn={isBopisFilterOn}
                    labelsBopis={plpLabels}
                    updateFormValue={updateFormValue}
                    setBopisFilterStateActn={setBopisFilterStateActn}
                    defaultStoreData={defaultStore}
                    resetSuggestedStores={resetSuggestedStores}
                    categoryNavData={{ navTree, currentNavIds }}
                    categoryPlp={false}
                    isPaginationViewEnabled={isPaginationViewEnabled}
                    selectedPageProductCount={selectedPageProductCount}
                    productLimitPerPage={productLimitPerPage}
                    selectedPage={selectedPage}
                    newFilterTrackAnalytics={newFilterTrackAnalytics}
                    trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                    isSizeGroupFilterEnabled={isSizeGroupFilterEnabled}
                    isCustomerRatingFilterWebEnabled={isCustomerRatingFilterWebEnabled}
                    isTileRedesignAB={isTileRedesignAB}
                    isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
                    isFeatureBrandView={isFeatureBrandView}
                    isFeatureBrandEnabled={isFeatureBrandEnabled}
                  />
                )}
              </Col>
            )}
            <Col colSize={!acrossBrandApiCalled ? this.colSize.variant4 : this.colSize.variant5}>
              {searchResultSuggestionsArg !==
                renderLabel(this.slpLabels.lbl_no_suggestion, 'lbl_no_suggestion') &&
                !isLoadingMore &&
                !isDidYouMeanEnabled && (
                  <Row className="empty-search-result-suggestion">
                    <Col colSize={this.colSize.variant1}>
                      <BodyCopy
                        fontSize={['fs22', 'fs24', 'fs32']}
                        component="div"
                        fontFamily="secondary"
                        fontWeight="semibold"
                        textAlign="center"
                      >
                        {`${renderLabel(this.slpLabels.lbl_didYouMean, 'lbl_didYouMean')} "`}
                        <Anchor
                          noLink
                          className="suggestion-label"
                          to={`/${getSiteId()}/search/${searchResultSuggestionsArg}`}
                          onClick={(e) => {
                            e.preventDefault();
                            redirectToSuggestedUrl(`${searchResultSuggestionsArg}`);
                          }}
                        >
                          {`${searchResultSuggestionsArg}`}
                        </Anchor>
                      </BodyCopy>
                    </Col>
                  </Row>
                )}
              {!isPromoProductsSearch && (
                <SearchKeywords
                  searchedText={searchedText}
                  isABTestForStickyFilter={isABTestForStickyFilter}
                  searchResultKeywordSuggestions={searchResultKeywordSuggestions}
                  slpPersistSearchTerm={slpPersistSearchTerm}
                  isSlpPersistEnabled={isSlpPersistEnabled}
                  isLoadingMore={isLoadingMore}
                  isDidYouMeanEnabled={isDidYouMeanEnabled}
                  isHeaderSticky={isHeaderSticky}
                  didYouMeanNullSearch={didYouMeanNullSearch}
                  totalProductsCount={totalProductsCount}
                  trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                  acrossBrandApiCalled={acrossBrandApiCalled}
                  searchTopPromos={searchTopPromos}
                  isSTSSearch={isSTSSearch}
                  isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
                  isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
                  isFeatureBrandView={isFeatureBrandView}
                  featureBrand={featureBrand}
                />
              )}
              <Row>
                <Col colSize={this.colSize.variant1}>
                  {searchTopPromos && searchTopPromos.length > 0 && (
                    <PromoModules
                      className="search-promo-container"
                      plpTopPromos={searchTopPromos}
                      asPath={asPathVal}
                      isLoggedIn={isLoggedIn}
                      isPlcc={isPlcc}
                      dynamicPromoModules={dynamicPromoModules}
                      currentListingName={currentListingName}
                    />
                  )}
                </Col>
              </Row>

              {isABTestForStickyFilter && !isShopThisStoreModeOn() ? (
                <Row className={stickySortClass}>
                  <Col colSize={{ small: 6, medium: 8, large: 2 }}>
                    <div className="sidebar desktop-filter-sidebar">
                      <ProductListingFiltersForm
                        isFilterBy={isFiltersAvailable(filters)}
                        filtersMaps={filterMaps}
                        totalProductsCount={totalProductsCount}
                        initialValues={initialValues}
                        filtersLength={filtersLength}
                        onSubmit={onSubmit}
                        formValues={formValues}
                        getProducts={getProducts}
                        isLoadingMore={isLoadingMore}
                        isSearchListing={isSearchListing}
                        isABTestForStickyFilter={isABTestForStickyFilter}
                        isBopisFilterOn={isBopisFilterOn}
                        updateFormValue={updateFormValue}
                        isPaginationViewEnabled={isPaginationViewEnabled}
                        selectedPageProductCount={selectedPageProductCount}
                        productLimitPerPage={productLimitPerPage}
                        selectedPage={selectedPage}
                        isBopisFilterEnabled={isBopisFilterEnabled}
                        setBopisFilterStateActn={setBopisFilterStateActn}
                        defaultStoreData={defaultStore}
                        resetSuggestedStores={resetSuggestedStores}
                        newFilterTrackAnalytics={newFilterTrackAnalytics}
                        trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                        sortByRatingLabel={sortByRatingLabel}
                        isFilterRedesign
                        isCustomerRatingFilterWebEnabled={isCustomerRatingFilterWebEnabled}
                        isTileRedesignAB={isTileRedesignAB}
                        asPathVal={asPathVal}
                        isOneHrFilterEnabled={isOneHrFilterEnabled}
                        isSLP
                        isFeatureBrandView={isFeatureBrandView}
                        isFeatureBrandEnabled={isFeatureBrandEnabled}
                      />
                    </div>

                    {/* UX timer */}
                    <RenderPerf.Measure name={CONTROLS_VISIBLE} />
                  </Col>
                  <Col colSize={this.colSize.variant2}>
                    {productsBlock.length ? (
                      <>
                        <Col colSize={this.colSize.variant1}>
                          <ProductListingFiltersForm
                            isFilterBy={isFiltersAvailable(filters)}
                            filtersMaps={filterMaps}
                            totalProductsCount={totalProductsCount}
                            initialValues={initialValues}
                            filtersLength={filtersLength}
                            onSubmit={onSubmit}
                            formValues={formValues}
                            getProducts={getProducts}
                            isLoadingMore={isLoadingMore}
                            isSearchListing={isSearchListing}
                            isABTestForStickyFilter={isABTestForStickyFilter}
                            isBopisFilterOn={isBopisFilterOn}
                            productsBlock={productsBlock}
                            isPaginationViewEnabled={isPaginationViewEnabled}
                            productLimitPerPage={productLimitPerPage}
                            updateFormValue={updateFormValue}
                            selectedPageProductCount={selectedPageProductCount}
                            selectedPage={selectedPage}
                            isBopisFilterEnabled={isBopisFilterEnabled}
                            setBopisFilterStateActn={setBopisFilterStateActn}
                            defaultStoreData={defaultStore}
                            resetSuggestedStores={resetSuggestedStores}
                            newFilterTrackAnalytics={newFilterTrackAnalytics}
                            trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                            isSizeGroupFilterEnabled={isSizeGroupFilterEnabled}
                            sortByRatingLabel={sortByRatingLabel}
                            isCustomerRatingFilterWebEnabled={isCustomerRatingFilterWebEnabled}
                            isTileRedesignAB={isTileRedesignAB}
                            asPathVal={asPathVal}
                            isOneHrFilterEnabled={isOneHrFilterEnabled}
                            isSLP
                            isFeatureBrandView={isFeatureBrandView}
                            isFeatureBrandEnabled={isFeatureBrandEnabled}
                          />
                        </Col>

                        {isSLPNewTileImplementationEnabled ? (
                          <SearchTileGridView {...sharedProps} {...newTileCommonProps} />
                        ) : (
                          <ProductsGrid
                            {...sharedProps}
                            {...oldTileCommonProps}
                            {...otherProps}
                            productsBlock={productsBlock}
                            isABTestForStickyFilter={isABTestForStickyFilter}
                            breadCrumbs={breadCrumbs}
                            alternateBrand={alternateBrand}
                            isSLP
                          />
                        )}
                        {/* UX timer */}
                        <RenderPerf.Measure name={RESULTS_VISIBLE} />
                      </>
                    ) : null}
                    {this.getSkeltonBlock(products)}
                  </Col>
                </Row>
              ) : (
                <>
                  <Row className={stickySortClass}>
                    <Col colSize={this.colSize.variant1}>
                      {!acrossBrandApiCalled && (
                        <ProductListingFiltersForm
                          isFilterBy={isFiltersAvailable(filters)}
                          filtersMaps={filterMaps}
                          totalProductsCount={totalProductsCount}
                          initialValues={initialValues}
                          filtersLength={filtersLength}
                          onSubmit={onSubmit}
                          formValues={formValues}
                          getProducts={getProducts}
                          isLoadingMore={isLoadingMore}
                          isSearchListing={isSearchListing}
                          isBopisFilterOn={isBopisFilterOn}
                          productsBlock={productsBlock}
                          isPaginationViewEnabled={isPaginationViewEnabled}
                          selectedPage={selectedPage}
                          productLimitPerPage={productLimitPerPage}
                          updateFormValue={updateFormValue}
                          selectedPageProductCount={selectedPageProductCount}
                          isBopisFilterEnabled={isBopisFilterEnabled}
                          setBopisFilterStateActn={setBopisFilterStateActn}
                          defaultStoreData={defaultStore}
                          resetSuggestedStores={resetSuggestedStores}
                          newFilterTrackAnalytics={newFilterTrackAnalytics}
                          trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                          isSizeGroupFilterEnabled={isSizeGroupFilterEnabled}
                          sortByRatingLabel={sortByRatingLabel}
                          isFilterRedesign
                          isCustomerRatingFilterWebEnabled={isCustomerRatingFilterWebEnabled}
                          isTileRedesignAB={isTileRedesignAB}
                          asPathVal={asPathVal}
                          isOneHrFilterEnabled={isOneHrFilterEnabled}
                          isSLP
                          isFeatureBrandView={isFeatureBrandView}
                          isFeatureBrandEnabled={isFeatureBrandEnabled}
                        />
                      )}
                      {/* UX timer */}
                      <RenderPerf.Measure name={CONTROLS_VISIBLE} />
                    </Col>
                  </Row>
                  {!acrossBrandApiCalled ? this.renderOldLoadedProductsCount() : ''}
                  <Row>
                    <Col colSize={this.colSize.variant1}>
                      {productsBlock.length && !hideOnPageChange ? (
                        <>
                          <ProductDisplay
                            acrossBrandApiCalled={acrossBrandApiCalled}
                            isSLPNewTileImplementationEnabled={isSLPNewTileImplementationEnabled}
                            crossBrandProducts={crossBrandProducts}
                            productsBlock={productsBlock}
                            alternateBrand={alternateBrand}
                            alternateBrandsShown={alternateBrandsShown}
                            resetSlpLoadingState={resetSlpLoadingState}
                            sharedProps={sharedProps}
                            newTileCommonProps={newTileCommonProps}
                            oldTileCommonProps={oldTileCommonProps}
                            otherProps={otherProps}
                          />

                          {/* UX timer */}
                          <RenderPerf.Measure name={RESULTS_VISIBLE} />
                        </>
                      ) : null}
                      {this.plpSkeletonCheck(isLoadingMore, products) ? (
                        <PLPSkeleton col={20} />
                      ) : null}
                    </Col>
                  </Row>
                </>
              )}
              {isPaginationViewEnabled && !acrossBrandApiCalled && (
                <Paginator
                  className="slp-pagination-bar"
                  currentPage={selectedPage}
                  totalCount={totalProductsCount}
                  pageSize={productLimitPerPage}
                  onPageChange={this.onPageChange}
                />
              )}
            </Col>
          </Row>
        </div>
        {toastModalState?.showToast && (
          <ToastModal
            className={className}
            duration={toastModalState?.duration}
            showToastModalAction={showToastModalAction}
          />
        )}
        {hasMounted && <Syte />}
      </>
    );
  }
}

SearchListingView.propTypes = SearchListingViewPropTypes;
SearchListingView.defaultProps = SearchListingViewDefaultProps;
const SearchListingViewWithRouter = withRouter(SearchListingView);

export default errorBoundary(withStyles(SearchListingViewWithRouter, SearchListingStyle));
export { SearchListingViewWithRouter as SearchListingViewVanilla };
